'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _web3Utils = require('web3-utils');

var _constants = require('../constants');

/**
 * Checks if address is in valid ethereum address format.
 *
 * If you want to treat the zero address as invalid, pass true for 2nd argument.
 *
 * @param {String|address} address
 * @param {Boolean?} rejectZeroAddress
 *
 * @return {Boolean}
 */
exports.default = function (address) {
  var rejectZeroAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0, _web3Utils.isAddress)(address) && (rejectZeroAddress ? address !== _constants.ZERO_ADDRESS : true);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/isAddress.js
// module id = 296
// module chunks = 0